import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import Login from './pages/Login';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import AuthAction from './pages/AuthAction';
import CookieNotice from './components/CookieNotice';
import InstallPrompt from './components/InstallPrompt';
import AgeGate from './components/AgeGate';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LanguageProvider } from './i18n/LanguageContext';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, user, setUser, authFetch, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-10 h-10 border-2 rounded-full animate-spin" style={{borderColor:'var(--accent)', borderTopColor:'transparent'}}></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // VERIFICAÇÃO DE IDADE TEMPORARIAMENTE DESATIVADA.
  // O componente AgeGate e as rotas do servidor foram mantidos para serem
  // revisados e reativados futuramente, sem bloquear a entrada no aplicativo.
  // if (!user?.adult_verified) {
  //   return <AgeGate authFetch={authFetch} onConfirmed={setUser} onLogout={logout}/>;
  // }

  return children;
}

function App() {
  useEffect(() => {
    document.documentElement.dataset.theme='midnight';
    document.documentElement.style.setProperty('--accent','#9d7be6');
  }, []);
  return (
    <LanguageProvider>
      <Router>
       <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/verify-email" element={<Navigate to="/login" replace />} />
          <Route path="/reset-password" element={<AuthAction purpose="reset" />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } />
        </Routes>
        <CookieNotice />
        <InstallPrompt />
       </AuthProvider>
      </Router>
    </LanguageProvider>
  );
}

export default App;
